import React from 'react'
import { makeStyles } from '@material-ui/styles';
import { Typography, Grid, Card } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import PositionedSnackBar from './PositionedSnackBar'

const useStyles = makeStyles(theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '3px 6px',
        width: '100%'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
        borderBottom: '1px solid lightgrey'
    },
    divContent: {
        padding: 12,
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    divContentButtons: {
        padding: 12,
        '& > Button': {
            margin: 5
        }
    },
    cardBody: {
        height: '100%'
    }
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function SnackBarComp() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };
    return (
        <div className={classes.root}>
            <div className={classes.titleDiv}>
                <Typography variant="h2">Snackbars</Typography>
            </div>
            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Customized snackbars
                            </Typography>
                        </div>
                        <div className={classes.divContent}>
                            <Button variant="outlined" onClick={handleClick}>
                                Open success snackbar
                            </Button>
                            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                                <Alert onClose={handleClose} severity="success">
                                    This is a success message!
                                </Alert>
                            </Snackbar>
                            <Alert severity="error">This is an error message!</Alert>
                            <Alert severity="warning">This is a warning message!</Alert>
                            <Alert severity="info">This is an information message!</Alert>
                            <Alert severity="success">This is a success message!</Alert>
                        </div>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} className={classes.gridItemInner}>
                    <Card className={classes.cardBody}>
                        <div className={classes.divTitle}>
                            <Typography variant="h5" color="inherit">
                                Positioned SnackBars
                            </Typography>
                        </div>
                        <div className={classes.divContentButtons}>
                            <PositionedSnackBar />
                        </div>
                    </Card>
                </Grid>

            </Grid>


        </div>

    )
}

export default SnackBarComp
